// Soft-delete local de conversas — armazena IDs ocultos no localStorage.
// O backend externo não expõe DELETE de tarefa, então mantemos a lista
// "deletada" do lado do cliente. Funciona em todas as páginas que usam
// useHiddenTasks() pois fazemos broadcast via storage event + window.
import { useEffect, useState, useCallback } from "react";

const STORAGE_KEY = "linkia_hidden_tasks";
const EVENT_NAME = "linkia:hidden-tasks-changed";

function read() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
    } catch {
        return [];
    }
}

function write(ids) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch {
        // sem espaço, ignora
    }
    window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function useHiddenTasks() {
    const [hidden, setHidden] = useState(() => read());

    useEffect(() => {
        const sync = () => setHidden(read());
        window.addEventListener(EVENT_NAME, sync);
        window.addEventListener("storage", sync);
        return () => {
            window.removeEventListener(EVENT_NAME, sync);
            window.removeEventListener("storage", sync);
        };
    }, []);

    const hide = useCallback((id) => {
        if (!id) return;
        const cur = read();
        if (cur.includes(id)) return;
        write([...cur, id]);
    }, []);

    const unhide = useCallback((id) => {
        if (!id) return;
        write(read().filter((x) => x !== id));
    }, []);

    const isHidden = useCallback((id) => hidden.includes(id), [hidden]);

    const filter = useCallback(
        (tasks) => (tasks || []).filter((t) => !hidden.includes(t.id)),
        [hidden]
    );

    return { hidden, hide, unhide, isHidden, filter };
}
